import React from 'react';
import {Field, reduxForm, focus} from 'redux-form';
import Input from './input';
import {login} from '../actions/auth';
import {required, nonEmpty} from '../validators';
import RaisedButton from 'material-ui/RaisedButton';
import './login-form.css'

const style = {
    margin: 12,
  };
  
export class LoginForm extends React.Component {
    onSubmit(values) {
        return this.props.dispatch(login(values.username, values.password));
    }

    render() {
        let error;
        if (this.props.error) {
            error = (
                <div className="form-error" aria-live="polite">
                    {this.props.error}
                </div>
            );
        }
        return (
            <form
                className="login-form"
                onSubmit={this.props.handleSubmit(values =>
                    this.onSubmit(values)
                )}>
                {error}
                <label className="label" htmlFor="username">Username</label>
                <Field
                    component={Input}
                    type="text"
                    name="username"
                    id="username"
                    validate={[required, nonEmpty]}
                />
                <label className="label" htmlFor="password">Password</label>
                <Field
                    component={Input}
                    type="password"
                    name="password"
                    id="password"
                    validate={[required, nonEmpty]}
                />
                <RaisedButton
                    label="Log in" 
                    primary={true} 
                    style={style} 
                    type="submit"
                    disabled={this.props.pristine || this.props.submitting}
                />
   
            </form>
        );
    }
}

export default reduxForm({
    form: 'login',
    onSubmitFail: (errors, dispatch) => dispatch(focus('login', 'username'))
})(LoginForm);

// import React from 'react';
// import {Field, reduxForm, focus} from 'redux-form';
// import Input from './input';
// import {login} from '../actions/auth';
// import {required, nonEmpty} from '../validators';
// import RaisedButton from 'material-ui/RaisedButton';
// import './login-form.css'

// const style = {
//     margin: 12,
//   };
  
// export class LoginForm extends React.Component {
//     onSubmit(values) {
//         return this.props.dispatch(login(values.username, values.password));
//     }

//     render() {
//         let error;
//         if (this.props.error) {
//             error = (
//                 <div className="form-error" aria-live="polite">
//                     {this.props.error}
//                 </div>
//             );
//         }
//         return (
//             <form
//                 className="login-form"
//                 onSubmit={this.props.handleSubmit(values =>
//                     this.onSubmit(values)
//                 )}>
//                 {error}
//                 <label htmlFor="username">Username</label>
//                 <Field
//                     component={Input}
//                     type="text"
//                     name="username"
//                     id="username"
//                     validate={[required, nonEmpty]}
//                 />
//                 <label htmlFor="password">Password</label>
//                 <Field
//                     component={Input}
//                     type="password"
//                     name="password"
//                     id="password"
//                     validate={[required, nonEmpty]}
//                 />
//                 <RaisedButton
//                     label="Log in" 
//                     primary={true} 
//                     style={style} 
//                     type="submit"
//                     disabled={this.props.pristine || this.props.submitting}
//                 />
   
//             </form>
//         );
//     }
// }

// export default reduxForm({
//     form: 'login',
//     onSubmitFail: (errors, dispatch) => dispatch(focus('login', 'username'))
// })(LoginForm);



// WEBPACK FOOTER //
// ./src/components/login-form.js